// @flow
import React from 'react';
import { connect } from 'react-redux';
import './stylesheets/GettingStarted.scss';

type GettingStartedProps = {
  entryEventName: string,
  show: boolean
};

const GettingStarted = (props: GettingStartedProps) => {
  if (!props.show) {
    return null;
  }
  return (
    <div className="GettingStarted">
      <h1 className="GettingStarted__Title">GETTING STARTED</h1>

      <div className="GettingStarted__HelpfulText">
        What do you want to happen after users perform{' '}
        <span className="GettingStarted__HelpfulText__Emphasis">
          {props.entryEventName}
        </span>? If you&#39;re not sure, try starting at the end and working
        your way back up. Don&#39;t worry, you can always add more steps later.
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { api: { isNewOrch } } = state;
  return {
    show: isNewOrch
  };
};

export default connect(mapStateToProps)(GettingStarted);



// WEBPACK FOOTER //
// ./src/components/GettingStarted.jsx